import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Trash2, Plus } from "lucide-react";

const blank = { title: "", category: "facilities", image_url: "", caption: "" };

export default function AdminPhotos() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState(blank);

  const load = () => api.get("/photos").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    await api.post("/photos", form);
    setForm(blank);
    load();
  };
  const del = async (id) => { await api.delete(`/photos/${id}`); load(); };

  return (
    <div data-testid="admin-photos">
      <div className="section-label">Media Library</div>
      <h1 className="font-display font-bold text-3xl text-slate-950 mt-2">Photos</h1>

      <div className="mt-8 bg-white border border-slate-200 p-6 rounded-md grid sm:grid-cols-2 gap-3">
        <input data-testid="photo-title" placeholder="Title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className="border border-slate-300 px-3 py-2" />
        <select data-testid="photo-category" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} className="border border-slate-300 px-3 py-2 bg-white">
          <option value="facilities">Facilities</option>
          <option value="aircraft">Aircraft</option>
          <option value="infrastructure">Historic / Infrastructure</option>
          <option value="events">Events</option>
        </select>
        <input data-testid="photo-url" placeholder="Image URL (https://...)" value={form.image_url} onChange={(e) => setForm({ ...form, image_url: e.target.value })} className="border border-slate-300 px-3 py-2 sm:col-span-2" />
        <input data-testid="photo-caption" placeholder="Caption (optional)" value={form.caption} onChange={(e) => setForm({ ...form, caption: e.target.value })} className="border border-slate-300 px-3 py-2 sm:col-span-2" />
        <button data-testid="photo-add" onClick={add} className="bg-slate-950 text-white px-4 py-2 sm:col-span-2 inline-flex items-center gap-2 justify-center"><Plus className="h-4 w-4" /> Add photo</button>
      </div>

      <div className="mt-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
        {list.map((p) => (
          <div key={p.id} className="relative group bg-slate-100">
            <img src={p.image_url} alt={p.title} className="w-full aspect-[4/3] object-cover" />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-end p-2 opacity-0 group-hover:opacity-100">
              <div className="text-white text-xs">
                <div className="font-semibold">{p.title}</div>
                <div className="text-sky-300 uppercase tracking-widest">{p.category}</div>
              </div>
            </div>
            <button data-testid={`photo-del-${p.id}`} onClick={() => del(p.id)} className="absolute top-2 right-2 bg-white/90 p-1.5 text-red-600 hover:bg-white">
              <Trash2 className="h-4 w-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
